import { replaceBackEndUrl, convertTitleToReadable } from '../api_tools'

export default class NewsArticle {
    fromRestData(restData) {
        this.url = replaceBackEndUrl(restData.link);
        this.ingress = null;
        this.id = restData.id;
        this.mobilePictureUrl = null;
        this.fullPictureUrl = null;

        if(restData.acf){
            this.acf = restData.acf;
        }else{
            this.acf = null;
        }

        let dateExploded = restData.date.split("T");
        let timeExploded = dateExploded[0].split("-");
        this.date = timeExploded[2] + "." + timeExploded[1]+".";

        if(this.acf.bannerImage){
            if(this.acf.bannerImage.image){
                this.fullPictureUrl = this.acf.bannerImage.image.url;
            }
            if(this.acf.bannerImage.mobileImage){
                this.mobilePictureUrl = this.acf.bannerImage.mobileImage.url;
            }
        }
        
        if(restData.acf && restData.acf.title && restData.acf.title.length > 0){
            this.h1 = restData.acf.title;
        }else{
            this.h1 = restData.title.rendered;
        }
        
        if(restData.acf.liftText){
            this.ingress = restData.acf.liftText;
        }

        this.title = convertTitleToReadable(restData.title.rendered);

        this.content = replaceBackEndUrl(restData.content.rendered);
        this.type = "post";
        
        if(restData.acf.bannerImage.image){
            // this.mediaIdFull = restData.acf.bannerImage.image;
            // this.mediaIdMobile = restData.acf.bannerImage.mobileImage;
            this.bgposition = "center center";

            if(restData.acf.bannerImage.imagePosition && restData.acf.bannerImage.imagePosition.length > 0){            
                let bgposition_split = restData.acf.bannerImage.imagePosition.split("_");
                this.bgposition = bgposition_split[0] + " " + bgposition_split[1];
            }
        }
    }
}